import React from "react";
import { AlertTriangle, Clock } from "lucide-react";
import { daysUntil } from "../lib/api";

/**
 * Timing chip for charges and payment rows.
 *
 * Rules (separate from charge/payment status):
 *   • Overdue  → due_date < today
 *   • Due soon → 0 <= days_until <= 3
 *   • else     → nothing rendered
 *
 * Pass `hideIfPaid` (default true) to suppress the chip on completed/confirmed
 * rows where the timing doesn't matter anymore.
 */
export default function DueChip({ dueDate, paymentStatus, chargeStatus, hideIfPaid = true, className }) {
  if (!dueDate) return null;
  if (hideIfPaid) {
    if (paymentStatus && ["confirmed", "waived"].includes(paymentStatus)) return null;
    if (chargeStatus && ["archived", "canceled"].includes(chargeStatus)) return null;
  }
  const d = daysUntil(dueDate);
  if (d == null) return null;

  if (d < 0) {
    return (
      <span
        data-testid="due-chip-overdue"
        className={`inline-flex items-center gap-1 rounded-full border border-rose-200 bg-rose-50 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-rose-700 ${className || ""}`}
      >
        <AlertTriangle className="h-3 w-3" />
        Overdue
      </span>
    );
  }
  if (d <= 3) {
    return (
      <span
        data-testid="due-chip-due-soon"
        className={`inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-amber-800 ${className || ""}`}
      >
        <Clock className="h-3 w-3" />
        Due soon
      </span>
    );
  }
  return null;
}
